/* eslint-disable formatjs/no-literal-string-in-jsx */
import { FormattedMessage } from "react-intl";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";

export const HorseTermsAndConditionsPdf = () => {
  return (
    <View paddingHorizontalLarge>
      <Text colorTheme sizeLarge>
        BAKGRUND
      </Text>
      <Spacer />
      <Text>
        Evidensia kommer att utföra undersökningar och behandlingar i enlighet
        med gällande lagar och regler och vara noggranna och omsorgsfulla vid
        utfärdande av intyg om djurs hälsotillstånd eller vård. Sjukvårdande
        behandlingar kan alltid innebära risker för djuret och det kan uppstå
        oförutsedda men naturligt förekommande komplikationer beroende på
        djurindividens fysiologiska förmåga och omgivande faktorer.
      </Text>
      <Spacer />

      <Text>
        I första hand är djurägaren betalningsansvarig för den Sjukvårdande
        behandlingen. För det fall djurägaren inte är betalningsansvarig åtar
        sig undertecknad att tillse att betalning sker enligt punkt 2 i
        Evidensias Allmänna Villkor. Du som skriver in djuret för behandling hos
        Evidensia måste kunna uppvisa giltig legitimation (oavsett om du är
        djurägare eller ombud).
      </Text>
      <Spacer />

      <Text>
        Evidensia behandlar personuppgifter i enlighet med GDPR och följer
        berörda myndigheters föreskrifter. Som kund hos oss godkänner du att
        provmaterial med tillhörande personuppgifter får delas till
        underleverantörer såsom laboratorier och andra diagnostiktjänsteföretag.
      </Text>
      <Spacer />

      <Text>
        Den information som finns i journalerna samt kopior på journalerna kan
        lämnas:
      </Text>
      <Spacer />

      <Text>
        - till andra kliniker/djursjukhus i samband med att djuret remitteras
        eller behandlas på annan klinik.
      </Text>
      <Spacer />
      <Text>
        - till försäkringsbolag i samband med kostnadsreglering eller förfrågan
        inför försäkring samt
      </Text>
      <Spacer />
      <Text>
        - till berörda myndigheter om felaktigheter eller brister upptäcks i
        djurets identitetshandlingar eller annan dokumentation kopplad till
        djuret.
      </Text>

      <Spacer />

      <Text>
        Provmaterial och relevant journaldata kan även komma att användas
        anonymiserat i forskningssammanhang. För mer information, se Evidensias
        integritetspolicy.
      </Text>

      <Spacer />
      <Text colorTheme sizeLarge>
        ALLMÄNNA VILLKOR HÄST FÖR VETERINÄRTJÄNSTER UTFÖRDA AV EVIDENSIA
      </Text>
      <Spacer />

      <Text>
        Dessa Allmänna villkor gäller för Sjukvårdande behandling som Evidensia
        utför på Hästägarens/Beställarens häst. Allmänna villkor är bindande och
        gäller mellan parterna. Det är viktigt att du noga läser igenom och
        godkänner dessa Allmänna villkor innan besöket.
      </Text>

      <Spacer />

      <Text colorTheme sizeMedium>
        1. SJUKVÅRDANDE BEHANDLING
      </Text>
      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`<b>Allmänt</b>: Evidensia ska i den mån det är möjligt anteckna omfattningen av den Sjukvårdande
behandlingen i journalen. Om Evidensia upptäcker efter Inskrivningen att det krävs någon annan
omfattning av den Sjukvårdande behandlingen ska detta antecknas i journalen och Beställaren
ska så snart det kan ske informeras om detta. Vid akut eller livshotande tillstånd hos hästen
behöver omfattningen av den Sjukvårdande behandlingen inte antecknas i journalen förrän efter
att den Sjukvårdande behandlingen utförts. Evidensia har alltid rätt att, helt eller delvis och utan
motivering, avböja att utföra Sjukvårdande behandling.`}
          id="A4Bx7L"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`<b>Besiktning</b>: Om den Sjukvårdande behandlingen utgörs av besiktning av hästens status, hälsa
eller därmed jämförbart tillstånd ska Evidensia i samband med Inskrivningen anteckna syftet med
besiktningen. Syftet kommer vara avgörande för nivån och omfattningen av besiktningen.
Hästägaren/Beställaren är medveten om att en besiktning alltid utgör en ögonblicksbedömning
och en subjektiv värdering.`}
          id="EpI0mc"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text colorTheme sizeMedium>
        2. KOSTNADER, BETALNINGSVILLKOR M.M
      </Text>
      <Spacer />

      <Text>
        Beställaren har rätt att få ett Kostnadsförslag från Evidensia för
        kostnaden för den Sjukvårdande behandlingen. Avsevärda förändringar i
        Kostnadsförslaget ska meddelas Beställaren så snart som möjligt.
        Beställaren har rätt att sätta ett Kostnadstak för den Sjukvårdande
        behandlingen. Kostnadstaket får inte överskridas utom när det är fråga
        om ett akut eller livshotande tillstånd hos hästen eller Beställaren
        inte kan nås i tid.
      </Text>

      <Spacer />

      <Text>
        Beställaren är i första hand betalningsansvarig för den Sjukvårdande
        behandlingen om inte annat särskilt överenskommits. Betalning sker
        antingen direkt på kliniken, via Klarna eller mot faktura om Beställaren
        är en näringsidkare. Profylaktisk vård och besiktningar ska alltid
        betalas direkt på kliniken eller via Klarna. Om så inte sker lämnar
        Evidensia inte ut intyg. Företagsfakturor ska betalas inom tio (10)
        dagar från fakturadatumet, fakturaavgift på åttio (80) kr tillkommer. Om
        fakturan inte betalas inom den tiden har Evidensia rätt att ta ut en
        påminnelseavgift om sextio (60) kr samt ränta på fakturabeloppet med en
        (1) procent per månad till dess att beloppet har betalats. Reservation
        för prisförändringar över tid.
      </Text>

      <Spacer />

      <Text>
        Vid direktreglering mot försäkringsbolag tillkommer
        direktregleringsavgift.
      </Text>

      <Spacer />

      <Text>
        Om Hästägaren/Beställaren inte hämtar sin häst inom avtalad tid efter
        att den Sjukvårdande behandlingen utförts har Evidensia rätt att ta
        betalt för hästens vistelse enligt gällande
        stationärvårdsavgift/dygnsavgift. Priser ska inkludera mervärdesskatt,
        om inte Evidensia anger något annat. Hästägaren/ Beställaren går med på
        att dennes betalningsskyldighet kommer att kvarstå, trots eventuella
        oförutsedda komplikationer eller att någon annan omfattning av den
        Sjukvårdande behandlingen än vad som antecknats i samband med
        Inskrivningen krävs.
      </Text>

      <Spacer />
      <Text colorTheme sizeMedium>
        3. REKLAMATION
      </Text>
      <Spacer />
      <Text>
        Inom ett (1) år från det att den Sjukvårdande behandlingen utförts kan
        en Hästägare/Beställare reklamera den Sjukvårdande behandlingen som har
        utförts av Evidensia. Om Hästägaren/Beställaren anser att den
        Sjukvårdande behandlingen utförts på ett felaktigt sätt och vill
        reklamera måste detta dock anmälas till Evidensia senast en (1) månad
        efter det att denne upptäckt eller borde ha upptäckt felet. Därefter får
        Hästägaren/Beställaren inte längre reklamera fel i den Sjukvårdande
        behandlingen, även om det inte har gått ett (1) år från det att den
        Sjukvårdande behandlingen utförts. Evidensia ska alltid ges möjlighet
        att korrigera ett fel som upptäcks inom rimlig tid efter att en
        reklamation mottagits. Då görs en veterinärmedicinsk bedömning av den
        Sjukvårdande behandlingen som utförts. Om Evidensia bedömer att man ej
        gjort fel hänvisas till Ansvarsnämnden för djurens hälso- och sjukvård
        (www.vetansvar.se).
      </Text>
      <Spacer />
      <Text colorTheme sizeMedium>
        4. ANSVARSBEGRÄNSNING
      </Text>
      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`<b>Allmänt</b>: Evidensia ersätter Hästägaren/Beställaren endast för skada som orsakats av
vårdslöshet eller försummelse vid utförandet av den Sjukvårdande behandlingen, dock inte
indirekt skada. Evidensia ersätter inte förlust, skada eller utebliven vinst i näringsverksamhet.
Ersättning enligt ovan betalas med ett högsta belopp om ett (1) prisbasbelopp (vid var tid
gällande enligt socialförsäkringsbalken), om inte något annat anges i dessa Allmänna villkor eller
i besiktningsintyget för häst.`}
          id="ExmxoP"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        Om utredning av Evidensias försäkringsbolag visar på att Evidensia är
        ersättningsskyldiga på grund av fastställt försumligt agerande och där
        den felaktiga behandlingen medfört att hästens brukbarhet helt upphört,
        kan Evidensia komma att ersätta Hästägaren/Beställaren med ett belopp
        motsvarande livvärdet för hästen upp till maximalt 1 miljon svenska
        kronor. I dessa fall skall hästens livvärde styrkas av oberoende aktör.
      </Text>

      <Spacer />

      <Text>
        Evidensia ersätter inte Hästägaren/Beställaren för skada till följd av
        att Hästägaren/Beställaren använder, eller förlitar sig på, ett
        besiktningsprotokoll för något annat syfte än det syfte som angavs i
        samband med Inskrivningen.
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`<b>Profylaktisk behandling på initiativ av Hästägaren/Beställaren</b>: Evidensia ersätter inte skada
till följd av profylaktisk behandling som utförts på initiativ av Hästägaren/Beställaren om
Evidensia dessförinnan har avrått Hästägaren/ Beställaren från behandlingen.`}
          id="Wyk0Yt"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />
      <Text colorTheme sizeMedium>
        5. ÄNDRING AV ALLMÄNNA VILLKOR
      </Text>
      <Spacer />
      <Text>
        Evidensia har rätt att när som helst ändra de Allmänna villkoren utan
        att dessförinnan informera Hästägaren/Beställaren. Evidensia ska dock
        informera Hästägaren/Beställaren om väsentliga ändringar och låta
        Hästägaren/Beställaren få del av de nya Allmänna villkoren genom att
        informera om ändringar på klinikerna och på hemsidan www.evidensia.se.
      </Text>
      <Spacer />

      <Text colorTheme sizeMedium>
        6. DEFINITIONER
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage="”<b>Allmänna villkor</b>” betyder dessa allmänna villkor för veterinärtjänster
        enligt dess senaste lydelse."
          id="+Z5RUs"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{ b: (chunks) => <Text weightBold>{chunks}</Text> }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`”<b>Beställaren</b>” betyder en person som är minst 18 år och som har ansvar för hästen som den
Sjukvårdande behandlingen avser vid Inskrivningen, antingen i egenskap av att själv vara
Hästägare eller enligt fullmakt från Hästägaren.`}
          id="YWqIuX"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage="”<b>Hästägaren</b>” betyder en person som är minst 18 år och som äger hästen som den
Sjukvårdande behandlingen avser."
          id="kHCY5B"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />
      <Text>
        <FormattedMessage
          defaultMessage="”<b>Dotterbolag</b>” betyder ett bolag (i) som direkt eller indirekt kontrollerar Evidensia; (ii) som är
under samma direkta eller indirekta ägande eller kontroll som Evidensia; eller (iii) som direkt eller
indirekt ägs eller kontrolleras av Evidensia. I det här sammanhanget ska ett bolag anses vara
kontrollerat av någon annan om det andra bolaget äger mer än femtio procent (>50%) av
rösterna i ett sådant bolag, kan styra bolagets angelägenheter eller kontrollera styrelsens, eller
motsvarande organs, sammansättning av styrelseledamöter eller motsvarande."
          id="HZxi+1"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage="”<b>Evidensia</b>” betyder det Dotterbolag inom Evidensia Djursjukvård AB, org.
        Nr 556880-7217, som utför den Sjukvårdande behandlingen."
          id="dnPxQW"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`”<b>Inskrivning</b>” betyder det förfarande genom vilket Hästägaren/Beställaren registrerar sin häst
hos Evidensia i anslutning till den Sjukvårdande behandlingen`}
          id="9ayVdY"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`”<b>Kostnadsförslag</b>” betyder en ungefärlig prisuppgift för den Sjukvårdande behandlingen som
Evidensia lämnar till Hästägaren/Beställaren i samband med Inskrivningen.`}
          id="Ix5QgD"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>
      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`”<b>Kostnadstak</b>” betyder uppgift om den högsta kostnaden för den Sjukvårdande behandlingen
som Evidensia, vid Hästägaren/Beställarens förfrågan, lämnar till Hästägaren/Beställaren i
samband med Inskrivningen.`}
          id="jXyZqz"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>
      <Spacer />
      <Text>
        <FormattedMessage
          defaultMessage={`<b>”Sjukvårdande behandling” betyder</b> varje åtgärd som vidtas för att medicinskt förebygga,
påvisa, lindra eller bota sjukdom, skada eller därmed jämförligt tillstånd hos djur; åtgärder för att
utföra operativa ingrepp på eller ge injektioner till djur i annat fall; inklusive, men inte begränsat
till, besiktningar av och utlåtanden om djurs status, hälsa eller därmed jämförbart tillstånd.`}
          id="d8n5n5"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>
    </View>
  );
};
